// PRIVATE API
export var State;
(function (State) {
    State["Login"] = "login";
    State["Signup"] = "signup";
    State["ForgotPassword"] = "forgot-password";
    State["ResetPassword"] = "reset-password";
    State["VerifyEmail"] = "verify-email";
})(State || (State = {}));
//# sourceMappingURL=types.js.map